import { Component } from '@angular/core';
import {ChartService} from '../../services/chart.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  email;
  password;
  error = '';
  spinnerOn = false;



  constructor(private service: ChartService, private router: Router, translate: TranslateService) {
    // Verify if the user is already authenticated
    this.service.authUser().onAuthStateChanged(user => {
      if (user != null) {
        // console.log('constructor loginComponent is on!!!!')
        this.router.navigate(['/home']);
      }
    });

    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    // get the language from cookie if it exists
    if (! this.service.checkCookie('language')) {
      const browserLang = translate.getBrowserLang();
      translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
    } else {
      translate.use(this.service.getCookie('language'));
    }

  }

  login(form) {
    if (form.valid) {
      this.spinnerOn = true;
      this.error = '';
      this.service.signIn(form.value.email, form.value.password).then(err => {
        this.error = err;
        this.spinnerOn = false;
      });
    }
  }


 }
